/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScheduleGroup } from './ScheduleGroup';
import {
    ScheduleGroupFromJSON,
    ScheduleGroupFromJSONTyped,
    ScheduleGroupToJSON,
    ScheduleGroupToJSONTyped,
} from './ScheduleGroup';

/**
 * 
 * @export
 * @interface BodyScheduleGroupTasksApiTasksScheduleGroupPost
 */
export interface BodyScheduleGroupTasksApiTasksScheduleGroupPost {
    /**
     * 
     * @type {number}
     * @memberof BodyScheduleGroupTasksApiTasksScheduleGroupPost
     */
    groupId: number;
    /**
     * 
     * @type {ScheduleGroup}
     * @memberof BodyScheduleGroupTasksApiTasksScheduleGroupPost
     */
    schedule: ScheduleGroup;
}

/**
 * Check if a given object implements the BodyScheduleGroupTasksApiTasksScheduleGroupPost interface.
 */
export function instanceOfBodyScheduleGroupTasksApiTasksScheduleGroupPost(value: object): value is BodyScheduleGroupTasksApiTasksScheduleGroupPost {
    if (!('groupId' in value) || value['groupId'] === undefined) return false;
    if (!('schedule' in value) || value['schedule'] === undefined) return false;
    return true;
}

export function BodyScheduleGroupTasksApiTasksScheduleGroupPostFromJSON(json: any): BodyScheduleGroupTasksApiTasksScheduleGroupPost {
    return BodyScheduleGroupTasksApiTasksScheduleGroupPostFromJSONTyped(json, false);
}

export function BodyScheduleGroupTasksApiTasksScheduleGroupPostFromJSONTyped(json: any, ignoreDiscriminator: boolean): BodyScheduleGroupTasksApiTasksScheduleGroupPost {
    if (json == null) {
        return json;
    }
    return {
        
        'groupId': json['group_id'],
        'schedule': ScheduleGroupFromJSON(json['schedule']),
    };
}

export function BodyScheduleGroupTasksApiTasksScheduleGroupPostToJSON(json: any): BodyScheduleGroupTasksApiTasksScheduleGroupPost {
    return BodyScheduleGroupTasksApiTasksScheduleGroupPostToJSONTyped(json, false);
}

export function BodyScheduleGroupTasksApiTasksScheduleGroupPostToJSONTyped(value?: BodyScheduleGroupTasksApiTasksScheduleGroupPost | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'group_id': value['groupId'],
        'schedule': ScheduleGroupToJSON(value['schedule']),
    };
}

